import {
    fetchWithTimeout,
    postWithUrl,
} from '@zmedia/bm-soccer-ui/utils/http';
import { IAuthState, IResponse } from '@zmedia/bm-soccer-ui/interface';
import {
    API_URL_BM,
    API_URL_BM_DEFAULT,
} from '@zmedia/bm-soccer-ui/constants/env';

const API_PATH = {
    GET_PROFILE: '/user/get/profile',
    LOGOUT: '/auth/post/logout',
    LOGIN_BY_ZALO: '/auth/post/login',
};

export const AuthService = {
    auth: (): Promise<IResponse<IAuthState>> => {
        return fetchWithTimeout(
            API_URL_BM + API_PATH.GET_PROFILE,
            {},
            {},
            1000
        );
    },
    logout: (): Promise<IResponse<IAuthState>> => {
        return postWithUrl(API_URL_BM_DEFAULT + API_PATH.LOGOUT);
    },
    loginByZalo: (
        oauthCode: string,
        codeVerifier: string
    ): Promise<IResponse<IAuthState>> => {
        return postWithUrl(
            API_URL_BM + API_PATH.LOGIN_BY_ZALO,
            {},
            { oauthCode, codeVerifier }
        );
    },
};

export default AuthService;
